export function getDueDateDisplay(dueDate: string | null): { text: string; isUrgent: boolean } {
  if (!dueDate) return { text: "—", isUrgent: false };

  let date: Date;
  if (dueDate.includes(".")) {
    const [dd, mm, yyyy] = dueDate.split(".");
    date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  } else {
    date = new Date(dueDate);
  }

  if (isNaN(date.getTime())) return { text: "—", isUrgent: false };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  const diffMs = date.getTime() - today.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    const absDays = Math.abs(diffDays);
    if (absDays > 30) return { text: `–${Math.round(absDays / 30)}м.`, isUrgent: true };
    return { text: `–${absDays}д.`, isUrgent: true };
  }
  if (diffDays <= 3) return { text: `${diffDays}д.`, isUrgent: true };
  if (diffDays <= 30) return { text: `${diffDays}д.`, isUrgent: false };
  return { text: `${Math.round(diffDays / 30)}м.`, isUrgent: false };
}
